import type {GeoCoordinates} from 'src/shared/utils/geoDistance';

export const GEO_CAPTURE_TIMEOUT_MS = 8000;
export const GEO_UNAVAILABLE_NOTE = 'Location unavailable on this device.';

/** Resolves to `undefined` (never rejects) when geolocation is unsupported/denied/timed out. */
export const captureGeoPosition = (): Promise<GeolocationPosition | undefined> =>
  new Promise(resolve => {
    if (!navigator.geolocation) {
      resolve(undefined);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      position => resolve(position),
      () => resolve(undefined),
      {timeout: GEO_CAPTURE_TIMEOUT_MS}
    );
  });

export interface CapturedGeoResult {
  latitude?: number;
  longitude?: number;
  geoNote?: string;
  coordinates?: GeoCoordinates;
}

/** Wraps `captureGeoPosition` into the coordinate/geoNote shape callers build transition requests from. */
export const captureGeoResult = async (): Promise<CapturedGeoResult> => {
  const position = await captureGeoPosition();
  const latitude = position?.coords.latitude;
  const longitude = position?.coords.longitude;
  const geoNote = position ? undefined : GEO_UNAVAILABLE_NOTE;
  const coordinates =
    latitude !== undefined && longitude !== undefined
      ? {latitude, longitude}
      : undefined;

  return {latitude, longitude, geoNote, coordinates};
};
